import { Box, Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import NotFilter from '../../../../shared/components/NotFilter'
import { Course, CourseProgress } from '../../models/course'
import CourseBlock from './CourseBlock'

interface CoursesContentCardsProps {
  authUser: any | null
  courses: Course[]
  coursesProgress: CourseProgress[]
  loading: boolean
  isMobile: boolean
  isTablet: boolean
  rowsPerPage: number
  onNextPage: () => void
}

const CoursesContentCards = ({
  authUser,
  courses,
  coursesProgress,
  loading,
  isMobile,
  isTablet,
  rowsPerPage,
  onNextPage
}: CoursesContentCardsProps) => {
  const { t } = useTranslation(['global'])

  return (
    <>
      {authUser !== null && (
        <Grid container spacing={isMobile ? 1 : 2} direction="row" alignItems="stretch">
          {courses.length === 0 && !loading ? (
            <NotFilter />
          ) : (
            courses.map(course => (
              <Grid key={course.id} item xs={6} sm={4} md={isTablet ? 6 : 4} lg={3} className="websiteCourse">
                <CourseBlock
                  course={course}
                  hasaccess={
                    course.visibility === 1 &&
                    (authUser.vip_lines.includes(course.line_id) ||
                      (course.line_id === null && authUser.vip_brands.includes(course.brand_id)) ||
                      [1, 2, 3, 5].includes(authUser.role_id))
                  }
                  progress={coursesProgress.find(courseProgress => courseProgress.course_id === course.id)}
                />
              </Grid>
            ))
          )}
        </Grid>
      )}

      {courses.length % rowsPerPage === 0 && (
        <Box mt={6} pb={4} style={{ textAlign: 'center' }}>
          <Button id="btn-see-more" variant="contained" size="large" color="primary" onClick={onNextPage}>
            {t('see-more')}
          </Button>
        </Box>
      )}
    </>
  )
}

export default CoursesContentCards
